import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { ButtonClose } from '@doltech/ui/lib/figma/ButtonClose/ButtonClose';
import { TestMainInfo } from '@doltech/ui/lib/figma/TestMainInfo/TestMainInfo';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import defaultBookCover from '../../img/book-covers/reading-book-cover.png';
import { useTestResultStore } from '../../model/test-result.hook';

const Main = styled.nav`
  display: flex;
  .top-nav-close-btn {
    margin-right: 16px;
  }
  .test-main-book-cover {
    width: 26px;
    object-fit: cover;
  }
`;

export interface TopNavigationMobileProps extends React.HTMLAttributes<HTMLDivElement> {
  onQuit?: () => void;
}

export const TopNavigationMobile = observer((props: TopNavigationMobileProps) => {
  const { onQuit } = props;
  const store = useTestResultStore();
  const { name, desc, bookCover, close } = store;

  return (
    <Main>
      <div className="top-nav-close-btn">
        <ButtonClose
          aria-label="Close"
          size="large"
          onClick={() => {
            if (onQuit) {
              onQuit();
              return;
            }
            close();
          }}
        >
          <IconOtherClose />
        </ButtonClose>
      </div>
      <TestMainInfo bookCover={bookCover || defaultBookCover} title={name} desc={desc} />
    </Main>
  );
});
